import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import Card from 'components/Card';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import StickyButtonPanel from 'components/StickyButtonPanel';
var ModalWrapper = function ModalWrapper(_ref) {
  var isEditMode = _ref.isEditMode,
    isLoading = _ref.isLoading,
    isSubmitDisabled = _ref.isSubmitDisabled,
    assetContentType = _ref.assetContentType,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    children = _ref.children,
    _ref$inContentManager = _ref.inContentManagerContext,
    inContentManagerContext = _ref$inContentManager === void 0 ? false : _ref$inContentManager;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = 'asset-editor-dialog-title';
  var modalTitle = isEditMode ? t(assetContentType ? "actions_edit_".concat(assetContentType) : 'actions_edit') : t(assetContentType ? "actions_add_".concat(assetContentType) : 'actions_add');
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            onSubmit();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var getLabel = function getLabel() {
    if (inContentManagerContext && isEditMode) {
      return t('actions_done');
    }
    if (isEditMode) {
      return t('actions_save_and_close');
    }
    return t('actions_save_and_add_to_playlist');
  };
  return /*#__PURE__*/React.createElement(Modal, {
    width: "wide",
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    id: "".concat(assetContentType, "-details-modal")
  }, /*#__PURE__*/React.createElement(Card, {
    as: "form",
    variant: "raised"
    // visible overflow is needed for the sticky footer panel
    ,
    overflow: "visible",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    sticky: true,
    title: modalTitle,
    titleId: titleId,
    onClose: onClose
  }), children, /*#__PURE__*/React.createElement(StickyButtonPanel, null, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    isDisabled: isSubmitDisabled,
    isLoading: isLoading
  }, getLabel()))));
};
export default ModalWrapper;